import { useMemo } from "react";
import { useFaultEvents, type FaultEvent } from "../../../../api/useFaultEvents";
const useSiblingEvents = (
  projectId: string,
  faultEventId: string,
): { previous: FaultEvent | null; next: FaultEvent | null } => {
  const { events } = useFaultEvents(projectId);

  return useMemo(() => {
    const currentEvent = events.find(event => event.id === faultEventId);
    if (!currentEvent) return { previous: null, next: null };

    const currentFaultNames = new Set(currentEvent.metadata.faults.map(fault => fault.name));
    const sortedFaultEvents = events
      .filter(event => {
        const faultNames = event.metadata.faults.map(fault => fault.name);
        return (
          faultNames.length === currentFaultNames.size &&
          faultNames.every(faultName => currentFaultNames.has(faultName))
        );
      })
      .sort((a, b) => a.startsAt.getTime() - b.startsAt.getTime());

    const eventIndex = sortedFaultEvents.findIndex(event => event.id === faultEventId);
    if (eventIndex === -1) {
      return { previous: null, next: null };
    }

    return {
      previous: sortedFaultEvents[eventIndex - 1] ?? null,
      next: sortedFaultEvents[eventIndex + 1] ?? null,
    };
  }, [events, faultEventId]);
};

export default useSiblingEvents;
